import { Controller } from "@hotwired/stimulus"

// UX for the 4-digit email-verification code form (auth/signin_email_code).
//
// Lives inside the layout's modal turbo-frame; talks to the modal controller
// via outlet to close the modal on successful submission.
//
// Replaces the second half of the inline `turbo:frame-render` handler and the
// `turbo:submit-end` handler in application.js.
export default class extends Controller {
  static targets = ["input", "submit"]
  static outlets = ["modal"]

  onInput(event) {
    const input = event.target
    const index = this.inputTargets.indexOf(input)

    if (input.value.match(/^\d$/)) {
      if (index < this.inputTargets.length - 1) {
        this.inputTargets[index + 1].focus()
      }
    } else if (input.value === '') {
      if (index > 0) {
        this.inputTargets[index - 1].focus()
        this.inputTargets[index - 1].select()
      }
    }

    const filledCount = this.inputTargets.filter(i => i.value !== '').length
    if (filledCount > 3) {
      this.submitTarget.removeAttribute('disabled')
    } else {
      this.submitTarget.setAttribute('disabled', 'disabled')
    }
  }

  onSubmit(event) {
    // Server redirects to /lk on real login; on wrong code it just re-renders
    // the form (200 + flash, no redirect). We use `redirected` (and not just
    // success) because both responses return 2xx — only a redirect signals
    // actual login.
    const response = event.detail.fetchResponse
    if (!response?.redirected) return
    if (this.hasModalOutlet) this.modalOutlet.close()
    window.location.reload()
  }
}
